/**
 * Plugin: auth-recovery.client.ts
 *
 * Intercepta errores de refresh token inválido que GoTrueClient lanza
 * automáticamente durante la hidratación, ANTES de que el auth store
 * pueda manejarlos. Limpia la sesión corrupta para evitar el error 400
 * en consola.
 *
 * Contexto: aunque la cookie y el refresh token están alineados a 7 días
 * (ver nuxt.config.ts), el refresh puede fallar igualmente por:
 *  - token revocado server-side (admin invalidó la sesión)
 *  - navegador limpió localStorage (Safari ITP, modo privado)
 *  - usuario hizo signOut en otra pestaña
 * En todos esos casos GoTrueClient lanza un 400 que ensucia consola y
 * dejaba al user en bucle "Invalid Refresh Token" hasta limpiar manual.
 */
export default defineNuxtPlugin({
  name: 'auth-recovery',
  // Ejecutar DESPUÉS del plugin de supabase para tener acceso al cliente
  dependsOn: ['supabase'],
  async setup() {
    const client = useSupabaseClient()

    try {
      // Intentar recuperar la sesión actual
      const { data: { session }, error } = await client.auth.getSession()

      if (error) {
        const msg = error.message || ''
        const isStaleToken =
          msg.includes('Refresh Token') ||
          msg.includes('refresh_token') ||
          msg.includes('Invalid Refresh Token') ||
          msg.includes('JWT expired') ||
          msg === 'Auth session missing!'

        if (isStaleToken) {
          // Limpiar la sesión corrupta del almacenamiento local
          // scope: 'local' = solo limpiar este navegador, no invalidar en servidor
          await client.auth.signOut({ scope: 'local' }).catch(() => {})
          console.info('[auth-recovery] Sesión expirada limpiada correctamente.')
        }
      }
    } catch {
      // Si falla completamente, forzar limpieza
      await client.auth.signOut({ scope: 'local' }).catch(() => {})
    }
  }
})
